export class IndividualSearchCriteria {
    public customerTypeId = 1;
    public includeInactive = true;
    public firstName: string;
    public middleName: string;
    public lastName: string;
    public dateOfBirth: Date;
    public customerIdentificationTypeId: number;
    public customerIdentificationValue: string;
    public customerCharacteristicTypeId: number;
    public addressLine1: string;
    public addressLine2: string;
    public city: string;
    public jurisdictionId: number;
    public countyId: number;
    public postalCode: string;
    public phoneNumber: string;
    public emailAddress: string;
    public exactSearch = true;
    public includeDeceased = true;
}
